import React, { useEffect, useState } from 'react'
import { Flex, FormField, PrimaryButton, space, Text } from '@workday/canvas-kit-react'
import { Pill } from '@workday/canvas-kit-preview-react'
import RespondAgencySelector from './RespondAgencySelector'
import { fetchAgencies } from '../models/WebAppRequests'
import { PrimaryButtonColors } from '../../components/CanvasThemes'
import { PPLoadingDots } from '../../components/PPLoadingDots'
import { AgencyModel } from '../../models/AgencyModel'

export type ConfigureFeedAgenciesSectionProps = {
  agencyIDs: string[]
  onChangeAgencyIDs: (agencyIDs: string[]) => void
}

const ConfigureFeedAgenciesSection = ({ agencyIDs, onChangeAgencyIDs }: ConfigureFeedAgenciesSectionProps) => {
  const [loadingAgencies, setLoadingAgencies] = useState(false)
  const [agencies, setAgencies] = useState<AgencyModel[]>([])
  const [showRespondAgencySelector, setShowRespondAgencySelector] = useState(false)

  const agencyIDList = agencyIDs.join()
  useEffect(() => {
    if (agencyIDs.length === 0) {
      setAgencies([])
    } else {
      setLoadingAgencies(true)
      fetchAgencies(agencyIDs, '', false, 'PRODUCTION', undefined)
        .then(loadedAgencies => {
          setAgencies(loadedAgencies)
        })
        .finally(() => setLoadingAgencies(false))
    }
  }, [agencyIDList])

  return (
    <FormField label="Agencies" required>
      {showRespondAgencySelector && (
        <RespondAgencySelector
          selectedAgencyIDs={agencyIDs}
          onSelectAgencyIDs={agencyIDs => {
            onChangeAgencyIDs(agencyIDs)
            setShowRespondAgencySelector(false)
          }}
          onCancel={() => setShowRespondAgencySelector(false)}
        />
      )}
      {loadingAgencies && agencies.length === 0 ? (
        <PPLoadingDots />
      ) : (
        <Flex flexDirection="column" gap={space.xxs} alignItems="start">
          {agencies.length === 0 ? (
            <Text typeLevel="body.small">No Agencies Selected</Text>
          ) : (
            <Flex flexDirection="row" flexWrap="wrap" gap={space.xs}>
              {agencies.map(agency => (
                <Pill key={agency.agencyID}>
                  <Pill.Label>{agency.shortName}</Pill.Label>
                  <Pill.IconButton
                    onClick={() => {
                      onChangeAgencyIDs(agencyIDs.filter(agencyID => agencyID !== agency.agencyID))
                    }}
                  />
                </Pill>
              ))}
            </Flex>
          )}
          <PrimaryButton
            onClick={event => setShowRespondAgencySelector(true)}
            colors={PrimaryButtonColors}
            size="small"
          >
            Find Agencies
          </PrimaryButton>
        </Flex>
      )}
    </FormField>
  )
}

export default ConfigureFeedAgenciesSection
